<template>
  <div v-if="show">
    <div class="skinTest">
      <img @click="close" src="../../assets/images/close1.png">
      <img src="../../../static/images/advertisingSpace.png" @click="goSkin">
      <span @click="goSkin"></span>
    </div>
  </div>
</template>

<script>
import {getCookie, isWeixin} from '../../assets/common/js/config'
import {customRequestAjax} from '@/axiosApi'

export default {
  name: 'skinTest',
  data () {
    return {
      show: true,
      skinInfo: {}
    }
  },
  props: {
    page: {
      type: String,
      default: ''
    }
  },
  mounted () {
  },
  methods: {
    close: function () {
      var that = this
      that.show = false
    },
    goSkin: function () {
      window.location.href = '/static/wx/html/38ylactpage/preSaleList.html'
    }
  }
}
</script>

<style scoped lang="scss">
  .skinTest {
    width: 100%;
    position: relative;
    padding: 0 0.11rem 0;
    /*margin-bottom: 0.1rem;*/
    img:nth-of-type(1) {
      width: 0.15rem;
      height: 0.15rem;
      position: absolute;
      right: 0.12rem;
    }
    img:nth-of-type(2) {
      width: 100%;
    }
    span {
      width: .55rem;
      height: .55rem;
      display: block;
      position: absolute;
      right: .18rem;
      bottom: .09rem;
    }
    .skindesc {
      font-size: .13rem;
      line-height: .17rem;
      position: absolute;
      top: .37rem;
      left: 1rem;
      width: 2.47rem;
      height: .51rem;
      color: #4B3E32;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
</style>
<style lang="scss">
  .collect_button_skin {
    .van-dialog__content {
      padding-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/advertisingSpace.vue